import React from 'react';
import { createPortal } from 'react-dom';
import Image from 'next/image';
import Button from '$/components/base/Button';
import CalcRadish from '$/components/CalcRadish';
import HeadLogo from '$/components/HeadLogo';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import useThemeStore from '$/store/useThemeStore';
import { useCommonStore } from '@/store/useCommonStore';
import { getEnv, navigate } from '@/common/agents';
import classNames from 'classnames';
import AI_ICON_LIGHT from './AI_light.svg';
import AI_ICON_DARK from './AI_dark.svg';
import style from './index.module.scss';
import UserCard from '../../UserCard';

interface AIToolsHeaderProps {
  title?: string;
  AIToolsHeaderLeftContent?: React.ReactNode;
  AIToolsHeaderCenterContent?: React.ReactNode;
  AIToolsHeaderRightContent?: React.ReactNode;
  hiddenAIIcon?: boolean;
  className?: string;
}
export default function AIToolsHeader({
  title,
  AIToolsHeaderLeftContent,
  AIToolsHeaderCenterContent,
  AIToolsHeaderRightContent,
  hiddenAIIcon = false,
  className,
}: AIToolsHeaderProps) {
  const theme = useThemeStore((state) => state.theme);
  const toLogin = useCommonStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const languageStore = useLanguageStore((state) => state.languageStore);
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());

  const goHomepage = () => {
    navigate({
      mode: 'url',
      url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
    });
  };

  return createPortal(
    <div className={classNames(style.header, className)}>
      {/* 左侧区域：Logo + 标题 + 左侧插槽 */}
      <div className={style.leftSection}>
        <div className={style.title} onClick={goHomepage}>
          <HeadLogo />
          <div className={style.line} />
          {!hiddenAIIcon && <Image src={theme === 'light' ? AI_ICON_LIGHT : AI_ICON_DARK} alt="ai_eraser" width={18} height={14} className={style.ai_icon} />}
          {title && <span>{title}</span>}
        </div>
        {AIToolsHeaderLeftContent}
      </div>

      {/* 中间区域：居中内容插槽 */}
      <div className={style.centerSection}>
        {AIToolsHeaderCenterContent}
      </div>

      {/* 右侧区域：右侧内容插槽 + 用户卡片 */}
      <div className={style.rightSection}>
        {AIToolsHeaderRightContent}
        {isUserLoggedIn
          ? (
            <>
              <UserCard />
              <CalcRadish />
            </>
          )
          : (
            <Button
              type="plain"
              onClick={() => {
                toLogin().then(() => {
                  initUserInfo();
                });
              }}
            >
              <IconFont name="userV3Bold" fontSize={16} />
              <div className={style.noLoginButton}>
                {languageStore.smartcatTranslationText(
                  (v) => v.RoboNeo_Web_login_content,
                )}
              </div>
            </Button>
          )}
      </div>
    </div>,
    document.body,
  );
}
